import React, {useState, useContext} from 'react';
import {Link, withRouter} from 'react-router-dom';
import authApi from '../services/api/auth';
import {GlobalContext} from "../context/GlobalState";
import "../styles/auth.scss";
import Logo from '../images/logo-full.svg';
import EmailIcon from '../images/icons/email-icon.svg';
import SVG from 'react-inlinesvg';
import SponsoredChannels from '../components/SponsoredChannels';
import ReactGA from 'react-ga';

const PasswordReset = ({history}) => {
  const {userData} = useContext(GlobalContext);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  if (userData && userData.accountLevel) {
    history.push('/home');
  }

  const updateEmail = e => {
    setEmail(e.target.value);
  };

  const handleSendRecoveryEmail = async e => {
    e.preventDefault();
    try {
      const data = {
        email,
      };

      const response = await authApi.recoverPassword(data);

      setEmailSent(true);

      ReactGA.event({
        category: 'User',
        action: 'Sent Password Recovery Email',
        value: email,
      });
    } catch (error) {
      if (typeof error.response.data === 'string') {
        console.log('ERROR:', error.response.data);
        setError(error.response.data);
      } else {
        console.log('ERROR:', error);
        setError('Please enter a valid email and password and try again.');
      }
    }
  };

  return (
    <div className="auth-container password-reset">
      <SponsoredChannels />

      <div className="form">
        <div className="logo-container">
          <img src={Logo} alt="logo"/>
        </div>
        {emailSent ? (
          <>
            <h1>We sent it! 🎉</h1>
            <p className="mt-0 mb-60">You'll receive a password recovery email shortly if you have an account.</p>
            <p className="login-link">Change your mind? <Link to='/login'>Log in instead</Link></p>
          </>
          ) :
          (
            <>
              <h1>Reset Password</h1>
              <p className="login-link">Did you remember it? <Link to='/login'>Log in</Link></p>
              {error && <p className="error">{error}</p>}
              <form>
                <div className="input-wrapper">
                  <input value={email} onChange={updateEmail} placeholder='Email' type='email' required/>
                  <SVG src={EmailIcon}/>
                </div>
                <button onClick={handleSendRecoveryEmail} className="button-primary wide">Send recovery email</button>
              </form>
            </>
          )}

        <div className="copyright">

        </div>
      </div>
    </div>
  );
};

export default withRouter(PasswordReset);
